import api from "./api";

export const ApiOptions = {
    getThnAjar: () => {
        return api.get(`/tahun`)
    },
    getLembaga: () => {
        return api.get(`/lembaga`)
    },
    sistem: () => {
        return api.get(`/sistem`)
    },
    role: (uuid:string) => {
        return api.get(`/role/${uuid}`)
    },
    LembagaList : () =>{
        return api.get(`/apakah/list-lembaga`)
    },
}